import { LucideIconData } from 'lucide-angular/icons/types';

export const RetencionesIcon: LucideIconData = [
  [
    'path',
    {
      d: 'M11.075 21.0476H4.9C3.85066 21.0476 3 20.1948 3 19.1429V12.4762C3 11.4242 3.85066 10.5714 4.9 10.5714H18.2C19.2493 10.5714 20.1 11.4242 20.1 12.4762M6.8 10.5714V6.7619C6.8 5.49897 7.30044 4.28776 8.19124 3.39473C9.08204 2.5017 10.2902 2 11.55 2C12.8098 2 14.018 2.5017 14.9088 3.39473C15.7996 4.28776 16.3 5.49897 16.3 6.7619V10.5714M18.2 17.2381V18.4167L19.055 18.9524M22 18.1905C22 20.2944 20.2987 22 18.2 22C16.1013 22 14.4 20.2944 14.4 18.1905C14.4 16.0865 16.1013 14.381 18.2 14.381C20.2987 14.381 22 16.0865 22 18.1905Z',
      key: 'retenciones',
    },
  ],
] as const;
